<span *ngIf="params?.state && spinnerName === params?.spinnerName" class="loading-wrap">
  <cmx-loading
    class="loading"
    [ngClass]="labelPosition"
    [size]="size"
    [descriptionShow]="descriptionShow"
    [label]="label"
  ></cmx-loading>
</span>
